import React from 'react';

import TripWarning from './TripWarning';
import {IconAlert} from '../../Icons';


const DifferentDayWarning = props => {
    return (
        <TripWarning
            icon={<IconAlert />}
            screenReaderText='Alert: Trip leaves on a different day than your request.'
            summaryText='Some of your trips leave on a different day than your request.'
            {...props}
        />
    );
};

export default DifferentDayWarning;